@if (vm().contract?.data?.contractStatus === ContractStatus.SENT_TO_SIGNATORY) {
  <h2 class="mt-14 flex items-center text-h1 font-semibold">
    {{ 'site_setup_contract_licensing_agreement' | translate }}
    <svg-icon
      size="sm"
      class="ml-2 text-primary-blue"
      [key]="'px-16-info'"
      [libUiTooltip]="titleTooltip"
      tooltipPosition="right-bottom"
    ></svg-icon>

    <ng-template #titleTooltip>
      <div class="typo-h5-book whitespace-pre-wrap">
        {{ 'site_setup_form_title_tooltip' | translate }}
      </div>
    </ng-template>
  </h2>

  @if (!vm().tokenError) {
    <lib-license-agreement-form [showAuthorizedCheckbox]="true" [showSignerEmail]="false"></lib-license-agreement-form>

    <div class="mt-10 flex justify-end gap-6 pb-10">
      <button class="btn-primary h-10" type="button" (click)="onSubmitLicenseAgreement()">
        {{ 'site_setup_contract_submit' | translate }}
      </button>
    </div>
  } @else {
    <h4 class="mt-14 flex items-center text-h1 font-semibold">Error getting contract...</h4>
  }
}

@if (vm().contract?.data?.contractStatus === ContractStatus.SIGNED) {
  <div class="flex h-full flex-col items-center">
    <svg-icon size="4xl" key="px-96-success" class="my-10"></svg-icon>

    <h1 class="mb-10 whitespace-pre-wrap text-center text-h1 font-semibold">
      {{ 'site_setup_form_signed_external_success_title1' | translate }}
      {{ 'site_setup_form_signed_external_success_title2' | translate: { input1: ownerName() } }}
    </h1>

    <h4 class="text-center text-h4 font-light text-text-secondary">
      {{ 'site_setup_form_signed_success_description1' | translate }}
      <span class="font-semibold">{{ vm().contract?.data?.signatoryEmail }}</span>
    </h4>
    <h4 class="mb-10 text-center text-h4 font-light text-text-secondary">
      {{ 'site_setup_form_signed_success_description2' | translate }}
      <button class="font-semibold text-primary-blue" (click)="onDownloadClick()">
        {{ 'site_setup_form_signed_success_description_link' | translate }}
      </button>
    </h4>
    <button class="btn-primary h-10" type="button" (click)="onCloseClick()">
      {{ 'site_setup_form_signed_external_success_button' | translate }}
    </button>
  </div>
}
